<template>
  <div class="page" v-loading="detailLoading">
    <div class="content">
      <!-- 头部 -->
      <Step :active="2" />
      <!-- 基本信息 -->
      <div class="base-info">
        <h2 class="title">基本信息：</h2>
        <div class="base-list">
          <div class="base-item" v-if="$store.state.user.defaultCompanyId">
            <div class="base-label">客户公司：</div>
            <div class="base-value">
              {{ dataForm.companyName }}
            </div>
          </div>
          <div class="base-item">
            <div class="base-label">下单客户：</div>
            <div class="base-value">
              {{ $store.state.user.name }}
            </div>
          </div>
          <div class="base-item">
            <div class="base-label">订单号：</div>
            <div class="base-value">
              <el-input
                style="width: 100%"
                placeholder="请填写贵公司标准采购订单号"
                v-model="dataForm.custOrderNo"
                size="mini"
                maxlength="100"
              />
            </div>
          </div>
          <div class="base-item">
            <div class="base-label">要求到货时间：</div>
            <div class="base-value">
              <el-date-picker
                v-model="dataForm.demandReceiveDate"
                type="date"
                :placeholder="$t('message.select')"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptions"
                clearable
                size="mini"
              >
              </el-date-picker>
            </div>
          </div>
        </div>
      </div>
      <!-- 收货地址 -->
      <Address
        style="margin-top: 16px"
        :companyId="dataForm.companyId"
        ref="address"
        @setAddressId="setAddressId"
        v-if="ready"
      />
      <div style="margin-top: 16px" class="options-left">
        <Invoice
          :companyId="dataForm.companyId"
          :invoiceActive="invoiceActive"
          @change="(v) => (invoiceActive = v)"
          @setInvoiceId="setInvoiceId"
          ref="invoice"
          v-if="ready"
        />
      </div>
      <div
        v-if="invoiceActive !== '30'"
        style="margin-top: 16px"
        class="options-right"
      >
        <Address
          :companyId="dataForm.companyId"
          ref="address2"
          :simple="true"
          @setAddressId="setAddressId2"
          v-if="ready"
        />
      </div>
      <div class="radio-wrap">
        <RadioSel
          title="支付方式"
          :options="[
            { label: '在线支付', value: '1' },
            { label: '公司转账', value: '2' },
            { label: '账期支付', value: '3' },
          ]"
          :value="dataForm.customerPaymentMethod"
          @change="(v) => (dataForm.customerPaymentMethod = v)"
        >
          <template slot="bottom">
            <div class="right" v-if="dataForm.customerPaymentMethod === '1'">
              <span>支持</span>
              <span>
                <img src="~@/assets/img/zfb.png" />
                支付宝、
              </span>
              <span>
                <img src="~@/assets/img/wx.png" />
                微信
              </span>
            </div>
            <div class="right" v-if="dataForm.customerPaymentMethod === '2'">
              款到发货：下单后企业转账至工自仪对公账户，到账后发货。
            </div>
          </template>
        </RadioSel>
        <RadioSel
          title="发货倾向"
          :options="[
            { label: '整单发货', value: '1' },
            { label: '先到先发', value: '2' }
          ]"
          :required="true"
          :value="dataForm.deliveryTendency"
          @change="(v) => (dataForm.deliveryTendency = v)"
        />
      </div>
      <!-- 商品明细 -->
      <div class="items-wrap">
        <div class="title-wrap">
          <h2 class="title">商品明细：</h2>
        </div>
        <ItemList
          :tableData="dataForm.payOrderItemRefactoryForms"
          @changeNum="changeNum"
          :lectotypeInquiryNo="lectotypeInquiryNo"
        />
        <!-- 底部内容 -->
        <div class="plc-bottom">
          <div class="plc-pagination">
            <el-pagination
              background
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="pageSize"
              layout="total, prev, pager, next, sizes, jumper"
              :total="dataForm.payOrderItemRefactoryForms.length"
            ></el-pagination>
          </div>
        </div>
      </div>
      <!-- 底部信息 -->
      <div class="bottom">
        <div class="bottom-flex">
          <div class="bottom-remark">
            <div>添加备注：</div>
            <el-input
              class="plc-textarea"
              type="textarea"
              maxlength="500"
              show-word-limit
              resize="none"
              :autosize="{ minRows: 4, maxRows: 6 }"
              v-model="dataForm.orderRemarks"
              placeholder="请输入备注"
            />
          </div>
          <div class="bottom-price">
            <div>
              商品含税总额（元）：<span class="red"
                >￥{{ dataForm.payMoney | formatePrice }}</span
              >
            </div>
            <div>
              税额（元）：<span>￥{{ dataForm.taxAmount | formatePrice }}</span>
            </div>
            <div>
              优惠(元)：
              <span>￥{{ dataForm.discountAmount | formatePrice }}</span>
            </div>
            <div>
              运费(元)：
              <span>￥{{ dataForm.expressFee | formatePrice }}</span>
            </div>
            <div>
              应付含税总额（元）：
              <span>￥{{ dataForm.totalPay | formatePrice }}</span>
            </div>
          </div>
        </div>
        <div class="bottom-btns">
          <div class="total-price">
            <span>应付含税总额(元)：</span>
            <span class="red">￥{{ dataForm.totalPay | formatePrice }}</span>
          </div>
          <div class="btn" v-loading="loading" @click="submit">提交订单</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Step from './order3/step'
import ItemList from './order3/itemList'
import Address from './order3/address'
import Invoice from './order3/invoice'
import RadioSel from './order3/radioSel'
import debounce from 'lodash/debounce'

export default {
  components: {
    Step,
    ItemList,
    Address,
    Invoice,
    RadioSel
  },
  data () {
    return {
      ready: false,
      dataForm: {
        orderSource: '',
        companyId: '',
        companyName: '',
        custOrderNo: '',
        payOrderItemRefactoryForms: [], // 选型商品
        payMoney: 0,
        taxAmount: 0,
        discountMoney: 0,
        expressFee: 0,
        totalPay: 0,
        orderRemarks: '',
        customerPaymentMethod: '1', // 支付方式 1 线上支付 2 公司转账
        deliveryTendency: '', // 发货倾向 1 整单发货 2 先到先发
        payType: '10', // 付款类型：全款10，其他20
        addressId: '', // 收货地址id
        invoiceId: '', // 发票信息
        addressId_bill: '', // 收票地址id
        payOrderAddress: {},
        payOrderAddressInvoice: {},
        demandReceiveDate: null
      },
      companyOptions: [],
      companyLoading: false,
      currentPage: 1,
      pageSize: 10,
      total: 0,
      loading: false,
      detailLoading: false,
      invoiceActive: '30',
      lectotypeInquiryNo: '', // 选型询价单号
      asAddress: false, // 同发货地址
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() < Date.now() - 3600 * 1000 * 24
        }
      },
    }
  },
  mounted () {
    this.lectotypeInquiryNo = this.$route.query.lectotypeInquiryNo
    this.init()
  },
  methods: {
    init () {
      const user = this.$store.state.user
      this.dataForm.companyId = user.defaultCompanyId
      this.dataForm.companyName = user.defaultCompanyName
      this.ready = true
    },
    setAddressId (addressId) {
      const { t } = this.$route.query
      const info = JSON.parse(sessionStorage.getItem('createOrder') || '{}')
      if (info.t + '' === t + '') {
        const obj = {
          orderSource: info.orderSource,
          payOrderItemRefactoryForms: info.shoppingCartFormList,
          addressId: addressId,
          addressId_bill: '',
          platformSource: 2,
          lectotypeInquiryNo: this.lectotypeInquiryNo || undefined
        }
        this.dataForm.addressId = addressId
        this.dataForm.orderSource = info.orderSource
        this.generateOrder(obj)
      }
    },
    generateOrder (obj) {
      let url = '/front/consumer/shopping/order/generateOrder'
      if(this.$store.state.user.corpUserInfo.customerId){
        url= '/front/consumer/shopping/order/generateOrderWebSite'
      }
      this.$http
        .post(url, obj)
        .then(({ data: res }) => {
          if (res.code === 0) {
            const {
              payMoney,
              taxAmount,
              discountMoney,
              expressFee,
              totalPay,
              payOrderItemRefactoryVos
            } = res.data
            this.dataForm.payMoney = payMoney
            this.dataForm.taxAmount = taxAmount
            this.dataForm.discountMoney = discountMoney
            this.dataForm.expressFee = expressFee
            this.dataForm.totalPay = totalPay
            this.dataForm.payOrderItemRefactoryForms = payOrderItemRefactoryVos
          }
        })
    },
    setAddressId2 (addressId) {
      this.dataForm.addressId_bill = addressId
    },
    setInvoiceId (invoiceId) {
      this.dataForm.invoiceId = invoiceId
    },
    companyRemoteMethod (str) {
      if (!str) return
      this.companyLoading = true
      this.$http
        .get(
          `/inter/qixinbao/fuzzyQueryByKeyword?keyword=${str}&matchType=ename&region=&skip=`
        )
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.companyOptions = res.data.map((item) => {
              return {
                ...item,
                label: item.companyName,
                value: item.companyName
              }
            })
          }
        })
        .finally(() => {
          this.companyLoading = false
        })
    },
    // 前端分页
    setFrontPage (data) {
      this.total = data.length
      this.currentPage = 1
      this.frontData = [...data]
      this.getFrontPage()
    },
    getFrontPage () {
      const start = (this.currentPage - 1) * this.pageSize
      const end = this.currentPage * this.pageSize
      this.dataForm.payOrderItemRefactoryForms = this.frontData.slice(start, end) // slice() 方法不会改变原始数组
    },
    // 分页 每页多少条改变
    handleSizeChange (val) {
      this.currentPage = 1
      this.pageSize = val
      this.getFrontPage()
    },
    // 分页 页码
    handleCurrentChange (val) {
      this.currentPage = val
      this.getFrontPage()
    },
    changeNum (row, index) {
      this.$set(this.dataForm.payOrderItemRefactoryForms, index, row)
      const obj = {
        orderSource: this.dataForm.orderSource,
        payOrderItemRefactoryForms: this.dataForm.payOrderItemRefactoryForms,
        addressId: this.dataForm.addressId,
        addressId_bill: '',
        platformSource: 2,
        lectotypeInquiryNo: this.lectotypeInquiryNo || undefined
      }
      this.generateOrder(obj)
    },
    // 提交订单
    submit: debounce(
      function () {
        if (!this.dataForm.addressId) {
          this.$message.warning('请选择收货地址')
          return
        }
        // 获取收货地址
        this.dataForm.payOrderAddress = this.$refs.address.getResult()
        // 如果要开票
        if (this.invoiceActive !== '30') {
          if (!this.dataForm.invoiceId) {
            this.$message.warning('请选择发票')
            return
          }
          this.dataForm.payOrderInvoice = this.$refs.invoice.getResult()
          if (!this.dataForm.addressId_bill && !this.asAddress) {
            this.$message.warning('请选择收票地址')
            return
          }
          // 获取收票地址
          this.dataForm.payOrderAddressInvoice = this.$refs.address2.getResult()
        }
        if (!this.dataForm.deliveryTendency) {
          this.$message.warning('请选择发货倾向')
          return
        }

        if (this.loading) {
          return false
        }

        const obj = {
          ...this.dataForm,
          lectotypeInquiryNo: this.lectotypeInquiryNo || undefined, // 选型商品型号
          platformSource: 2
        }
        // 同收货地址功能
        if (this.asAddress && this.invoiceActive !== '30') {
          obj.addressId_bill = this.dataForm.addressId
          obj.payOrderAddressInvoice = JSON.parse(JSON.stringify(this.dataForm.payOrderAddress))
        }
        // 不开发票
        if (this.invoiceActive === '30') {
          delete obj.payOrderInvoice
          delete obj.payOrderAddressInvoice
          delete obj.addressId_bill
        }
        // 选项商品至少填写一个数量
        if (this.lectotypeInquiryNo) {
          obj.payOrderItemRefactoryForms = obj.payOrderItemRefactoryForms.filter(item => item.goodsNum > 0)
          if (obj.payOrderItemRefactoryForms.length === 0) {
            this.$message.warning('请填写至少一个选型商品数量')
            return
          }
        }
        // 用户选完把内容拼接到备注里
        if (this.dataForm.deliveryTendency === '1') {
          obj.orderRemarks = '发货倾向：整单发货。' + obj.orderRemarks
        } else if (this.dataForm.deliveryTendency === '2') {
          obj.orderRemarks = '发货倾向：先到先发。' + obj.orderRemarks
        }
        this.loading = true

        let url = '/front/consumer/shopping/order/submitOrder'
         // 企业站
        if(this.$store.state.user.corpUserInfo.customerId){
          url = '/front/consumer/shopping/order/submitOrderWebSite'
        }
        // 询价单
        if(this.lectotypeInquiryNo){
          url = '/front/commodity/manager/lectotypeInquiry/record/submitOrder'
        }
        this.$http
          .post(url,obj)
          .then(({ data: res }) => {
            if (res.code !== 0) {
              return false
            } else {
              this.$store.dispatch(
                'setShoppingCartCount',
                this.$store.state.shoppingCartCount + 1
              )
              // 选型询价商品则跳转立即支付
              if (this.lectotypeInquiryNo) {
                this.$router.push({
                  name: 'orderPay',
                  query: {
                    id: res.data,
                    money: this.dataForm.totalPay
                  }
                })
              } if (this.dataForm.customerPaymentMethod === '2') {
                // 如果是转账支付的话，跳转到转账支付页面
                this.$router.push({
                  name: 'enterpriseTransferPayment',
                  query: {
                    id: res.data,
                    money: this.dataForm.totalPay
                  }
                })
              } else {
                this.$router.replace({
                  name: 'orderDetail',
                  params: {
                    id: res.data
                  }
                })
              }
            }
          })
          .finally(() => {
            this.loading = false
          })
      },
      1000,
      {
        leading: true,
        trailing: false
      }
    )
  }
}
</script>

<style lang="scss" scoped>
.page {
  height: 100%;
  overflow: auto;
  padding-bottom: 28px;
  background: url('~@/assets/img/plc/bg1.png') no-repeat;
  background-size: 100% 100%;
  background-attachment: fixed;
  background-color: rgb(245, 248, 255);
}

.content {
  display: flex;
  flex-direction: column;
  width: 1200px;
  margin: 16px auto 0;
  background: url('~@/assets/img/plc/bg2.png') no-repeat;
  background-size: 100% 100%;
  background-attachment: fixed;
  border-radius: 12px;
}

.title {
  display: flex;
  font-size: 16px;
  margin: 0;
  color: #000000;
}

.base-info {
  background: #fff;
  padding: 16px 28px;
  border-radius: 12px;
  margin-top: 16px;
  .base-list {
    display: flex;
    flex-wrap: wrap;
    .base-item {
      display: flex;
      align-items: center;
      width: 33.33%;
      margin-top: 8px;
    }
    .base-label {
      display: flex;
      align-items: center;
      font-size: 14px;
      color: #3d3d3d;
      &.required::before {
        display: inline-block;
        content: '*';
        margin-right: 2px;
        font-size: 14px;
        color: #e93037;
      }
    }
    .base-value {
      padding-right: 28px;
      flex: 1;
    }
  }
}

.items-wrap {
  background: #fff;
  margin-top: 16px;
  border-radius: 12px;
}

.title-wrap {
  padding: 16px 28px;
}

.bottom {
  background: #fff;
  margin-top: 16px;
  border-radius: 12px;
  .red {
    color: #e93037;
    font-weight: 900;
    font-size: 20px;
  }
  .bottom-price {
    padding-left: 16px;
    text-align: right;
    font-size: 16px;
    color: #666666;
    > div {
      padding-bottom: 8px;
    }
  }
  .bottom-btns {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    border-top: 1px solid #efeff2;
    padding: 10px 28px;
    .total-price {
      display: flex;
      align-items: center;
      color: #000;
      font-size: 12px;
    }
    .btn {
      min-width: 95px;
      height: 36px;
      padding: 8px 12px;
      border-radius: 8px;
      background: #2a54d1;
      font-size: 18px;
      font-weight: bold;
      line-height: 20px;
      color: #ffffff;
      margin-left: 12px;
      cursor: pointer;
      &:hover {
        opacity: 0.8;
      }
      &.save {
        background: rgba(42, 84, 209, 0.4);
      }
    }
  }
}

.bottom-flex {
  display: flex;
  padding: 16px 28px 4px;
  .bottom-remark {
    flex: 1;
    > div {
      font-size: 14px;
      color: #3d3d3d;
      padding: 0 0 5px;
    }
  }
}

.radio-wrap {
  display: flex;
  align-items: center;
  justify-content: space-between;
  > div {
    width: calc(50% - 8px);
  }
}

.right {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  color: #3d3d3d;
  span {
    display: flex;
    align-items: center;
    line-height: 21px;
  }
  img {
    width: 18px;
    margin: 0 2px 0 4px;
  }
}
</style>
